import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import paymentSagas from './payment/saga';
import merchantSagas from './merchant/saga';
import deviceSagas from './device/saga';
import menuSagas from './menu/saga';
import membergroupSagas from './membergroup/saga';
import memberSagas from './member/saga';
import serviceSagas from './service/saga';
import gatewaySagas from './gateway/saga';
export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    paymentSagas(),
    merchantSagas(),
	 deviceSagas(),
	 menuSagas(),
	 membergroupSagas(),
	 memberSagas(),
	 serviceSagas(),
	 gatewaySagas()
  ]);
}
